import React, { Component } from "react";
import { connect } from "react-redux";
import { Row, Col, Badge, Alert, Table } from "react-bootstrap";

import Layout from "../layout";
import VcCard from "./VcCard";
import ErrorModal from "../error/ErrorModal";
import LoadingAnimation from "../loading";
import { getVc } from "../../actions";

class Vc extends Component {
  componentDidMount() {
    if (!this.props.vc) {
      this.props.getVc();
    }
  }

  buildCard(card, i) {
    const coworkers = card.coworkers
      .filter((co) => co[1] !== "70")
      .map((us) => us[0]);
    let lead = card.coworkers.filter((ld) => ld[1] === "70").map((us) => us[0]);
    if (lead.length > 1) lead = lead.join(", ");
    return (
      <VcCard
        key={i}
        index={i}
        szsitename={card.szsitename ? card.szsitename : "No site name"}
        vcCode={card.szUserDefinedSiteID ? card.szUserDefinedSiteID : "N/A"}
        assignmentDate={
          card.dtoperationdate ? card.dtoperationdate.split(" ")[0] : "N/A"
        }
        scheduledHours={
          card.startTime && card.endTime
            ? [card.startTime, card.endTime]
            : ["N/A", ""]
        }
        isSetupDay={card.isSetupDay ? true : false}
	
        setupTime={
	// null/undefined check in case no Voting Center is assigned
          card?.vcSetup?.SetUpTimeForPass ? card?.vcSetup?.SetUpTimeForPass : "N/A"
        }
        hideHourDisclaimer={card.hideHourDisclaimer ? true : false}
        siteLocation={card.szSiteLocation1 ? card.szSiteLocation1 : "N/A"}
        siteAddress={
          card.szSiteLocation2 && card.szSiteLocation3
            ? `${card.szSiteLocation2}, ${card.szSiteLocation3}`
            : "N/A"
        }
        lead={lead ? lead : ""}
        coworkers={coworkers ? coworkers : []}
      />
    );
  }

  buildCardDeck(items) {
    const currDate = new Date();
    if (items.length > 0) {
      const lastItem = { ...items[items.length - 1] };
      lastItem.startTime = "8:00 AM";
      lastItem.endTime = "5:00 PM";
      lastItem.dtoperationdate = "9/15/2021 12:00:00 AM";
      lastItem.hideHourDisclaimer = true;
      items.push(lastItem);

		//comment/uncomment to exclude/include set up times
       const firstItem = { ...items[0] };
       firstItem.isSetupDay = true;
       firstItem.hideHourDisclaimer = true;
       items.unshift(firstItem);
	   //end of set up day card
    }
    const deck = items
      .filter((card) => {
        const cardDate = new Date(card.dtoperationdate);
        cardDate.setDate(cardDate.getDate() + 1);
        return cardDate > currDate;
      })
      .map((card, i) => {
        return this.buildCard(card, i);
      });
    const pastItems = items
      .filter((card) => {
        const cardDate = new Date(card.dtoperationdate);
        cardDate.setDate(cardDate.getDate() + 1);
        return new Date(cardDate) < currDate;
      })
      .map((card, i) => {
        return this.buildCard(card, i);
      });
    return deck.length > 0 || pastItems.length > 0 ? (
      [deck, pastItems]
    ) : (
      <h1>
        <Badge variant={"dark"} className="text-center">
          No assignments
        </Badge>
      </h1>
    );
  }

  buildSupervisorDeck(rows) {
    return (
      <>
        <h2 className="mb-4 text-left">CSRs by Site</h2>
        <Table striped bordered hover responsive>
          <thead>
            <tr>
              <td>CSR ID</td>
              <td>CSR Title</td>
              <td>First Name</td>
              <td>Last Name</td>
              <td>Site Name</td>
              <td>Site ID</td>
            </tr>
          </thead>
          <tbody>
            {rows.map((row, i) => {
              const {
                EOID,
                sPositionAbbr,
                szNameFirst,
                szNameLast,
                szSiteName,
                szUserDefinedSiteID,
              } = row;
              return (
                <tr key={i}>
                  <td>{EOID}</td>
                  <td>{sPositionAbbr}</td>
                  <td>{szNameFirst}</td>
                  <td>{szNameLast}</td>
                  <td>{szSiteName}</td>
                  <td>{szUserDefinedSiteID}</td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </>
    );
  }

  renderContent() {
    if (this.props.vc) {
      const { rows } = this.props.vc;
      if (!Array.isArray(rows)) {
        return <ErrorModal />;
      } else if (rows.length === 0) {
        return (
          <Alert variant="info">
            <Alert.Heading>No Vote Center Assignments Available</Alert.Heading>
            <hr />
            You will be see all your past and future assignments here once they
            have been entered into the system.
          </Alert>
        );
      } else if (this.props.auth.isSupervisor) {
        return this.buildSupervisorDeck(rows);
      } else {
        const [future, past] = this.buildCardDeck(rows);
        return (
          <>
            {future.length > 0 && (
              <>
                <h2 className="text-left">Upcoming Assignments</h2>
                <br />
                {future}  
              </>
            )}
            {future.length > 0 && past.length > 0 && (
					 <>
			 <hr className="w-50 mb-5 mt-5" />
			   
			   
			    </>
            )}
            {
				
			}
            {future.length === 0 && past.length === 0 && (
              <h1>
                <Badge variant="info">No Assignments Found</Badge>
              </h1>
            )}
          </>
        );
      }
    }
    return <LoadingAnimation />;
  }

  render() {
    return (
      <Layout title="Vote Center">
        <Row>
          <Col className="mb-4">
            You will meet your team at your assigned Vote Center on Set Up Day.
            Your assigned Supervisor for the area will also be onsite to provide
            support. This is an important step in your Vote Center Customer
            Service Representative assignment in which you will familiarize
            yourself with your Vote Center, room set up and meet your fellow
            CSRs as you prepare for Opening Day of Vote Centers.
            <br />
            <br />
            Your scheduled Vote Center Set Up information is listed below. A
            couple things to note:
            <ul>
              <li>Work as a team to set up your Vote Center</li>
              <li>Unload the POD, keeping safety as priority</li>
              <li>
                Unload items individually, and if needed in sections if too
                heavy
              </li>
              <li>
                While the hours are 8:00 am to 5:00 pm, once you have completed
                set up, you are excused for the day and will be paid hours
                worked
              </li>
              <li>
                The ePollbooks will be delivered to your site directly the day
                of set up
              </li>
            </ul>
          </Col>
        </Row>
        <Row className="mb-3 mt-3">
          <Col>
            <h2>
              <Badge variant="success">
                Welcome {`${this.props.auth.name.split(" ")[0]}!` || "!"}
              </Badge>
            </h2>
          </Col>
        </Row>
        <hr className="w-50 mb-5 mt-5" />
        <Row>
          <Col>{this.renderContent()}</Col>
        </Row>
      </Layout>
    );
  }
}

const mapStateToProps = (state) => {
  return { vc: state.empData.vc, auth: state.auth };
};

export default connect(mapStateToProps, { getVc })(Vc);
